import { render, staticRenderFns } from "./NewBusinessDialog.vue?vue&type=template&id=c798c07c&scoped=true&"
import script from "./NewBusinessDialog.vue?vue&type=script&lang=ts&"
export * from "./NewBusinessDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewBusinessDialog.vue?vue&type=style&index=0&id=c798c07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c798c07c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
